import FlagshipProvider, { LogLevel } from "@flagship.io/react-sdk";
import applyFlagshipPrefix from "../utilities/experiments/applyFlagshipPrefix";
import { useCookieConsent } from "../utilities/useCookieConsent";

export const FlagshipWrapper = ({ children }) => {
  if (
    process.env.GATSBY_ENVIRONMENT === "loadtest" ||
    process.env.GATSBY_BRAND !== "PGUK" ||
    process.env.GATSBY_TEST_MODE === "true"
  ) {
    return children;
  }

  const isFunctionalConsentGiven = useCookieConsent("functional");

  return (
    <FlagshipProvider
      envId={process.env.GATSBY_FLAGSHIP_ENVID}
      apiKey={process.env.GATSBY_FLAGSHIP_APIKEY}
      visitorData={{
        hasConsented: isFunctionalConsentGiven,
        context: {
          group: applyFlagshipPrefix("group"),
        },
      }}
      logLevel={
        process.env.GATSBY_ENVIRONMENT === "production"
          ? LogLevel.ERROR
          : LogLevel.WARNING
      }
      trackingManagerConfig={{
        batchIntervals: 1,
      }}
    >
      {children}
    </FlagshipProvider>
  );
};

export default FlagshipWrapper;
